import jwtDecode from 'jwt-decode';

import { getCookie } from './cookies';

/**
 * SSO Token JWT Payload
 * @typedef {{authorities: string[]; perc: string}} DecodedSsoToken
 */

/**
 * Possible role enum present in sso_token
 *
 * (inlined from mf-common)
 */
export const UserRoleType = {
    Member: 'MEMBER',
    Owner: 'ENROLLED_OWNER',
    PendingOwner: 'OWNER',
    Admin: 'PRODUCT_ADMIN',
};

/**
 * Try to get and decode sso_token from cookies.
 * Returns null if failed.
 *
 * @returns {DecodedSsoToken | null}
 */
export function getSsoToken() {
    try {
        const rawSsoToken = getCookie('sso_token');

        if (rawSsoToken === undefined) {
            return null;
        }

        return jwtDecode(rawSsoToken);
    } catch {
        return null;
    }
}

/**
 * @param {DecodedSsoToken} ssoToken
 */
export function getIsMemberRole(ssoToken) {
    if (!ssoToken) {
        console.warn('Failed member role check while constructing routes'); // eslint-disable-line
        return false;
    }

    const roles = ssoToken.authorities || [];
    const isOwner = roles.includes(UserRoleType.Owner) || roles.includes(UserRoleType.PendingOwner);
    const isAdmin = roles.includes(UserRoleType.Admin);

    return !isOwner && !isAdmin;
}

/**
 * @param {DecodedSsoToken} ssoToken
 */
export function getIsAdminRole(ssoToken) {
    if (!ssoToken) {
        console.warn('Failed admin role check while constructing routes'); // eslint-disable-line
        return false;
    }

    const userRoles = ssoToken.authorities || [];
    const isAdmin = userRoles.includes(UserRoleType.Admin);
    return isAdmin;
}
